import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AdcontrolProfile from "../../../models/AdcontrolProfile";
import { SlotObject } from "@/components/TimeSlotPicker.vue";
import MultiSelectBroadcaster, {
  Agency,
} from "@/models/MultiSelectBroadcaster";
import { API_ENDPOINT } from "@/constants";
import axios from "axios";
import { MultiSelectOption } from "@/components/MultiSelect.vue";

export type ReportProduct = MultiSelectOption & {
  id: number;
  name: string;
};

export type ReportBrand = MultiSelectOption & {
  products: ReportProduct[];
};

export type ReportCompany = MultiSelectOption & {
  brands: ReportBrand[];
};

export type ReportClass = MultiSelectOption & {};

export type ReportCategory = MultiSelectOption & {
  classes: ReportClass[];
};
export type ReportSector = MultiSelectOption & {
  categories: ReportCategory[];
};

@Component({})
export default class ReportProductMixin extends Vue {
  @Getter("profile") mixinProfile!: AdcontrolProfile;

  async getProducts(
    type: string,
    startsAt: string,
    endsAt: string,
    comparisonStartsAt?: string,
    comparisonEndsAt?: string,
    timeSlots?: SlotObject[],
    competitors?: MultiSelectBroadcaster[],
    agencies?: Agency[]
  ): Promise<ReportCompany[]> {
    const url =
      API_ENDPOINT +
      `/${this.mixinProfile.slug}/${type}/competing_products.json`;

    const competitorIds = competitors?.map((c) => c.id);
    const agencyIds = agencies?.map((c) => c.id);

    const params = {
      startsAt,
      endsAt,
      comparisonEndsAt,
      comparisonStartsAt,
      timeSlots,
      competitors: competitorIds,
      agencies: agencyIds,
    };

    return await axios({
      url,
      params,
      method: "GET",
    }).then((res) => {
      return res.data.data as ReportCompany[];
    });
  }

  async getTemplateProducts(type: string): Promise<ReportCompany[]> {
    const url =
      API_ENDPOINT +
      `/${this.mixinProfile.slug}/${type}/competing_products/template_options.json`;

    return await axios({
      url,
      method: "GET",
    }).then((res) => {
      return res.data.data as ReportCompany[];
    });
  }

  async getClasses(
    type: string,
    startsAt: string,
    endsAt: string,
    comparisonStartsAt?: string,
    comparisonEndsAt?: string,
    timeSlots?: SlotObject[],
    competitors?: MultiSelectBroadcaster[],
    agencies?: Agency[]
  ): Promise<ReportSector[]> {
    const url =
      API_ENDPOINT +
      `/${this.mixinProfile.slug}/${type}/competing_classes.json`;

    const competitorIds = competitors?.map((c) => c.id);
    const agencyIds = agencies?.map((c) => c.id);

    const params = {
      startsAt,
      endsAt,
      comparisonEndsAt,
      comparisonStartsAt,
      timeSlots,
      competitors: competitorIds,
      agencies: agencyIds,
    };

    return await axios({
      url,
      params,
      method: "GET",
    }).then((res) => {
      return res.data.data as ReportSector[];
    });
  }

  async getTemplateClasses(type: string): Promise<ReportSector[]> {
    const url =
      API_ENDPOINT +
      `/${this.mixinProfile.slug}/${type}/competing_classes/template_options.json`;

    return await axios({
      url,
      method: "GET",
    }).then((res) => {
      return res.data.data as ReportSector[];
    });
  }
}
